export namespace HybridZhCn {
    export function factory() {
        return {
            header: {
                home: '首页',
                property: '推荐房源',
                blog: '我的博客',
            },
            footer: {
                admin: '管理员入口',
                copyright: '版权所有 © 2019 RIFO',
            },
            '1': '我们会通知您关于服务商的具体信息，同时，会将您的信息提供给服务商。', // appointment body-info
            '2': '用户', // appointment client name
            '3': '确认预约', // submit button
            '4': '有效期', // expiry Date
            '5': '客服', // customer Services
            '6': '服务已预约', // appointment success body title
            '7': '感谢您选择RIFO为您提供的优质服务，您可以随时在“我的订单”中查看您的订单状态。', // hybrid-services-appointment-body-info
            '8': '返回首页', // go home
            '9': '查看订单', // go my order
            '10': '购买成功', // purchase succeed
            '11': '感谢选择RIFO为您提供的优质服务，您可以随时在“我的优惠券”中查看您购买的优惠券。', // purchase succeed thx
            '12': '交易取消', // purchase cancelled
            '13': '交易取消，如有任何问题，请联系客服 (416) 883-9666。', // after purchase cancelled
            '14': '交易失败', // purchase failed
            '15': '交易失败，请稍后重试。如仍无法下单，请联系客服 (416) 883-9666。', // after purchase failed please
            '16': '返回', // go back
            '17': '账户信息异常，没有资源信息，请尽快联系客服 (416) 883-9666', // user info error
            '18': 'RIFO优惠券', // default coupon title
            '19': '省钱省时省心', // default coupon subtitle
            '20': '登录/注册', // login button
            '21': '进入我的账户', // go my account
            '22': '购买', // go paypage
            '23': '使用', // appointment
            '24': '我的订单', // go my order
            '25': '已失效', // inactive
            '26': '已退款', // REFUNDED
            '27': '已删除', // DISCARDED
            '28': '买房有好礼', // default slogan
            '29': '请进入APP查看', // find detials
            '30': '重新发送', // resend
            '31': '点击确认收取短信验证码，\r\n并修改预留电话号码，\r\n注意：该操作将会修改用户账户中的电话信息。', //
            '32': '验证码输入错误',
            '33': '预约成功',
            '34': '非常感谢您选择RIFO. 我们正在委派服务，请您稍后留意',
            '35': '电话（10位数字）', // phoneInput placeholder
            '36': '请输入验证码', // codeVarify placeholder
            '37': '手机号已被注册，请核实，客服电话：(416) 883-9666',
            '38': '验证超时',
            '39': '重新发送',
            '40': '详情',
            '41': '已失效',
            '42': '有效期',
            '43': '我的优惠券',
            '44': '使用',
            '45': '待发放',
            '46': 'RIFO 房屋评估',
            '47': '我的房子值多少钱？',
            '48': 'RIFO旗下的认证经纪为您: 免费提供专业的不动产价值预估',
            '49': '立即获取估价',
            marketingTrend: {
                '1': '过去1个月',
                '2': '中位价',
                '3': '新上市房源',
                '4': '年度中位价变化',
                '5': '月度中位价变化',
                '6': '成交量',
                '7': '平均成交时长',
                '8': '平均成交价',
                '9': '平均要价/成交价比',
                'graph1': {
                    'title': '成交价与在市天数历史对比',
                    'label1': '在市天数',
                    'label2': '中位价',
                    'label3': '中位价 / K',
                    'label4': '在市天数 / 天',
                },
                'graph2': {
                    'title': '平均成交价 / K',
                },
                'graph3': {
                    'title': '中位价 / K',
                },
                'graph4': {
                    'title': '平均成交时长 / 天',
                },
                'graph5': {
                    'title': '售价/标价 %',
                },
                'graph6': {
                    'title': '成交量 / 套',
                },
                'graph7': {
                    'title': '房屋类型销量分布图（180天）',
                },
                'graph8': {
                    'title': '售价分布图（180天）',
                    'label1': '销量(K）'
                },
                'graph9': {
                    'title': '售出 / 新增 / 在售房源',
                    'label1': '售出',
                    'label2': '新增',
                    'label3': '在售'
                },
                'graph10': {
                    'title': '市场热度',
                    'label1': '消化率（%）',
                    'label2': '消化所需月数',
                    'formatter': '{b1}<br/>{a0}: {c0}<br/>{a1}: {c1}',
                    'p1': '消化所需月: 作为一般规则，5至6个月的库存被认为是正常或平衡的市场。超过6个月的库存，就是买方市场。不到5个月，就是卖方市场。可用库存越小，市场就越紧张。请记住，这些只是指导方针，因市场而异。',
                    'p2': '消化率: 传统上，消化率高于20％已经表明卖方市场很快就会出售房屋。低于15％的消化率是买方市场的一个指标，其中房屋的销售速度并不快'
                }
            },
            communityTrend: {
                '1': '社区详情信息',
                '2': '经济区:',
                '3': '省份:',
                '4': '普查区域:',
                '5': '公民',
                '6': '非公民',
                '7': '业主',
                '8': '租客',
                '9': '固定工作人口',
                '10': '非固定工作人口',
            }
        };
    }
}
